import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_AUTOMATION](state, payload) {
    state.automation = payload;
  },
  [MutationsType.SET_AUTOMATIONS](state, payload) {
    state.automations = payload;
  },
  [MutationsType.ADD_AUTOMATION](state, payload) {
    state.automations.unshift(payload);
  },
  [MutationsType.UPDATE_AUTOMATION](state, payload) {
    let ind = state.automations?.findIndex((automation) => automation.id === payload.id);
    if (ind >= 0) Vue.set(state.automations, ind, { ...state.automations[ind], ...payload });

    if (state.automation?.id === payload.id) state.automation = { ...state.automation, ...payload };
  },
  [MutationsType.DELETE_AUTOMATION](state, payload) {
    let ind = (state.automations || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.automations, ind);
  },
};
